import lazyWithPreload from 'react-lazy-with-preload'

export const SignUp = lazyWithPreload(async () => await import('./auth/sign-up/sign-up'))
export const SignUpInviteExpedited = lazyWithPreload(async () => await import('./auth/SignUpInviteExpedited/SignUpInviteExpedited'))
export const SignUpTransferExpedited = lazyWithPreload(async () => await import('./auth/SignUpTransferExpedited/SignUpTransferExpedited'))
export const Login = lazyWithPreload(async () => await import('./auth/Login'))
export const ForgotPassword = lazyWithPreload(async () => await import('./auth/ForgotPassword'))
export const ResetPassword = lazyWithPreload(async () => await import('./auth/ResetPassword'))
export const SubscriptionInterstitial = lazyWithPreload(async () => await import('./auth/Subscription/SubscriptionInterstitial'))

export const SignUpNew = lazyWithPreload(async () => await import('./auth/sign-up-new/sign-up'))

export const Dashboard = lazyWithPreload(async () => await import('./dashboard/Dashboard'))

export const SettingsHome = lazyWithPreload(async () => await import('./settings/SettingsHome'))

export const TermsOfService = lazyWithPreload(async () => await import('./misc/TermsOfService'))

// export const NewAirframe = lazyWithPreload(async () => await import('./airframe/NewAirframe'))
export const AirframeInvite = lazyWithPreload(async () => await import('./airframe/AirframeInvite'))
export const AirframeDetail = lazyWithPreload(async () => await import('./airframe/AirframeDetail/AirframeDetail'))
